//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: 'à¼¡',
            2: 'à¼¢',
            3: 'à¼£',
            4: 'à¼¤',
            5: 'à¼¥',
            6: 'à¼¦',
            7: 'à¼§',
            8: 'à¼¨',
            9: 'à¼©',
            0: 'à¼ ',
        },
        numberMap = {
            'à¼¡': '1',
            'à¼¢': '2',
            'à¼£': '3',
            'à¼¤': '4',
            'à¼¥': '5',
            'à¼¦': '6',
            'à¼§': '7',
            'à¼¨': '8',
            'à¼©': '9',
            'à¼ ': '0',
        };

    var bo = moment.defineLocale('bo', {
        months: 'à½à¾³à¼à½à¼à½à½à¼à½à½¼_à½à¾³à¼à½à¼à½à½à½²à½¦à¼à½_à½à¾³à¼à½à¼à½à½¦à½´à½à¼à½_à½à¾³à¼à½à¼à½à½à½²à¼à½_à½à¾³à¼à½à¼à½£à¾à¼à½_à½à¾³à¼à½à¼à½à¾²à½´à½à¼à½_à½à¾³à¼à½à¼à½à½à½´à½à¼à½_à½à¾³à¼à½à¼à½à½¢à¾à¾±à½à¼à½_à½à¾³à¼à½à¼à½à½à½´à¼à½_à½à¾³à¼à½à¼à½à½à½´à¼à½_à½à¾³à¼à½à¼à½à½à½´à¼à½à½à½²à½à¼à½_à½à¾³à¼à½à¼à½à½à½´à¼à½à½à½²à½¦à¼à½'.split(
            '_'
        ),
        monthsShort:
            'à½à¾³à¼1_à½à¾³à¼2_à½à¾³à¼3_à½à¾³à¼4_à½à¾³à¼5_à½à¾³à¼6_à½à¾³à¼7_à½à¾³à¼8_à½à¾³à¼9_à½à¾³à¼10_à½à¾³à¼11_à½à¾³à¼12'.split(
                '_'
            ),
        monthsShortRegex: /^(à½à¾³à¼\d{1,2})/,
        monthsParseExact: true,
        weekdays:
            'à½à½à½ à¼à½à½²à¼à½à¼_à½à½à½ à¼à½à¾³à¼à½à¼_à½à½à½ à¼à½à½²à½à¼à½à½à½¢à¼_à½à½à½ à¼à½£à¾·à½à¼à½à¼_à½à½à½ à¼à½à½´à½¢à¼à½à½´_à½à½à½ à¼à½à¼à½¦à½à½¦à¼_à½à½à½ à¼à½¦à¾¤à½ºà½à¼à½à¼'.split(
                '_'
            ),
        weekdaysShort: 'à½à½²à¼à½à¼_à½à¾³à¼à½à¼_à½à½²à½à¼à½à½à½¢à¼_à½£à¾·à½à¼à½à¼_à½à½´à½¢à¼à½à½´_à½à¼à½¦à½à½¦à¼_à½¦à¾¤à½ºà½à¼à½à¼'.split(
            '_'
        ),
        weekdaysMin: 'à½à½²_à½à¾³_à½à½²à½_à½£à¾·à½_à½à½´à½¢_à½¦à½à½¦_à½¦à¾¤à½ºà½'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[à½à½²à¼à½¢à½²à½] LT',
            nextDay: '[à½¦à½à¼à½à½²à½] LT',
            nextWeek: '[à½à½à½´à½à¼à½à¾²à½à¼à½¢à¾à½ºà½¦à¼à½], LT',
            lastDay: '[à½à¼à½¦à½] LT',
            lastWeek: '[à½à½à½´à½à¼à½à¾²à½à¼à½à½à½ à¼à½] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s à½£à¼',
            past: '%s à½¦à¾à½à¼à½£',
            s: 'à½£à½à¼à½¦à½',
            ss: '%d à½¦à¾à½¢à¼à½à¼',
            m: 'à½¦à¾à½¢à¼à½à¼à½à½à½²à½',
            mm: '%d à½¦à¾à½¢à¼à½',
            h: 'à½à½´à¼à½à½¼à½à¼à½à½à½²à½',
            hh: '%d à½à½´à¼à½à½¼à½',
            d: 'à½à½²à½à¼à½à½à½²à½',
            dd: '%d à½à½²à½à¼',
            M: 'à½à¾³à¼à½à¼à½à½à½²à½',
            MM: '%d à½à¾³à¼à½',
            y: 'à½£à½¼à¼à½à½à½²à½',
            yy: '%d à½£à½¼',
        },
        preparse: function (string) {
            return string.replace(/[à¼¡à¼¢à¼£à¼¤à¼¥à¼¦à¼§à¼¨à¼©à¼ ]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /à½à½à½à¼à½à½¼|à½à½¼à½à½¦à¼à½à½¦|à½à½²à½à¼à½à½´à½|à½à½à½¼à½à¼à½à½|à½à½à½à¼à½à½¼/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'à½à½à½à¼à½à½¼' && hour >= 4) ||
                (meridiem === 'à½à½²à½à¼à½à½´à½' && hour < 5) ||
                meridiem === 'à½à½à½¼à½à¼à½à½'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'à½à½à½à¼à½à½¼';
            } else if (hour < 10) {
                return 'à½à½¼à½à½¦à¼à½à½¦';
            } else if (hour < 17) {
                return 'à½à½²à½à¼à½à½´à½';
            } else if (hour < 20) {
                return 'à½à½à½¼à½à¼à½à½';
            } else {
                return 'à½à½à½à¼à½à½¼';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bo;

})));
